const findKeyByValue = (obj: object, value: unknown) => {
  const objEntries = Object.entries(obj);

  for (const [key, values] of objEntries) {
    if (values.includes(value)) {
      return key;
    }
  }

  return null;
};

export default findKeyByValue;
